import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import userRoleService from '../../../../services/userRoleService';

const CreateRole = () => {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim()) {
      alert('Role name is required');
      return;
    }

    try {
      setLoading(true);

      await userRoleService.createRole({
        name,
        description,
        is_active: isActive
      });

      navigate('/admin/roles'); 
    } catch (err) {
      console.error('Create role failed', err);
      alert('Failed to create role');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-management">
      <div className="page-header">
        <h1>Create Role</h1>
        <p>Add a new system role</p>
      </div>

      <div className="form-card">
        <div className="form-group">
          <label>Role Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter role name"
          />
        </div>

        <div className="form-group">
  <label>Description</label>
  <textarea
    className="form-textarea"
    placeholder="Enter role description"
    value={description}
    onChange={(e) => setDescription(e.target.value)}
    rows={4}
  />
</div>

        <div className="form-group">
          <label>Status</label>
          <select
  value={isActive ? 'active' : 'inactive'}
  onChange={(e) => setIsActive(e.target.value === 'active')}
>
  <option value="active">Active</option>
  <option value="inactive">Inactive</option>
</select>
        </div>

        <div className="form-actions">
          <button
            className="btn btn-outline"
            onClick={() => navigate('/admin/roles')}
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Creating...' : 'Create Role'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateRole;
